import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const Label = ({ label, children, classNames, styles, ...rest }) => (
  <label className={classnames('block', classNames.label)} style={styles.label} {...rest}>
    {label && (
      <span
        className={classnames('font-bold text-sm text-black', classNames.span)}
        style={styles.span}
      >
        {label}
      </span>
    )}
    {children}
  </label>
)

Label.propTypes = {
  label: PropTypes.string,
  styles: PropTypes.shape({
    label: PropTypes.object,
    span: PropTypes.object,
  }),
  classNames: PropTypes.shape({
    label: PropTypes.string,
    span: PropTypes.string,
  }),
}

Label.defaultProps = {
  classNames: {},
  styles: {},
}

export default Label
